<div
    class="fixed inset-0 z-[20000] bg-black/60 flex items-center justify-center p-4"
    role="dialog"
    aria-modal="true"
    aria-labelledby="booking-v2-tour-title">
    <u2b-dialog class="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh]">

        <div u2bDialogHeader class="contents">
            <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-full bg-white/20 inline-flex items-center justify-center">
                    <span class="material-icons text-[1.375rem] text-p-primary-contrast" aria-hidden="true">{{ currentStep().icon }}</span>
                </div>
                <h1 class="text-xl font-semibold m-0 text-p-primary-contrast">{{ 'bookingV2.tour.title' | translate }}</h1>
            </div>
            <u2b-icon-button
                variant="on-primary"
                icon="close"
                [ariaLabel]="('bookingV2.tour.closeAria' | translate)"
                (clicked)="close()" />
        </div>

        <div u2bDialogSubheader class="bg-p-surface-50 border-b border-p-border px-6 py-5 flex flex-col items-center gap-2">
            <div class="flex items-center justify-center gap-2" role="tablist" [attr.aria-label]="('bookingV2.tour.progressAria' | translate)">
                @for (step of steps; track $index; let i = $index) {
                    <button
                        type="button"
                        role="tab"
                        class="appearance-none border-0 p-0 cursor-pointer rounded-full h-2.5 transition-[width,background-color] duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-p-primary focus-visible:outline-offset-2"
                        [class.w-6]="i === stepIndex()"
                        [class.w-2.5]="i !== stepIndex()"
                        [class.bg-p-primary]="i <= stepIndex()"
                        [class.opacity-40]="i < stepIndex()"
                        [class.bg-p-surface-200]="i > stepIndex()"
                        [attr.aria-selected]="i === stepIndex()"
                        [attr.aria-label]="('bookingV2.tour.stepOfAria' | translate: { current: i + 1, total: totalSteps })"
                        (click)="goTo(i)">
                    </button>
                }
            </div>
            <span class="text-[0.8125rem] text-p-text-muted">
                {{ 'bookingV2.tour.stepOf' | translate: { current: stepIndex() + 1, total: totalSteps } }}
            </span>
        </div>

        <h2 id="booking-v2-tour-title" class="m-0 mb-3 text-xl font-semibold text-p-text leading-snug">
            {{ currentStep().titleKey | translate }}
        </h2>
        <p class="m-0 mb-4 text-p-text leading-relaxed text-[0.9375rem]">
            {{ currentStep().descriptionKey | translate }}
        </p>
        @if (currentStep().tipKey) {
            <div class="bg-blue-50 border border-blue-200 rounded-p-sm px-3 py-2.5 flex items-start gap-2">
                <span class="material-icons text-blue-600 text-base mt-0.5 flex-shrink-0" aria-hidden="true">help_outline</span>
                <p class="m-0 text-[0.8125rem] text-blue-800 leading-snug">{{ currentStep().tipKey | translate }}</p>
            </div>
        }

        <div u2bDialogFooter class="contents">
            <p-button
                severity="secondary"
                [text]="true"
                [label]="'bookingV2.tour.skip' | translate"
                (onClick)="close()">
            </p-button>
            <div class="flex items-center gap-2">
                @if (!isFirst()) {
                    <p-button
                        severity="secondary"
                        [outlined]="true"
                        (onClick)="previous()"
                        [attr.aria-label]="('bookingV2.tour.previousAria' | translate)">
                        <span pButtonIcon class="material-icons">chevron_left</span>
                        <span pButtonLabel>{{ 'bookingV2.tour.previous' | translate }}</span>
                    </p-button>
                }
                @if (isLast()) {
                    <p-button (onClick)="close()">
                        <span pButtonIcon class="material-icons">check_circle</span>
                        <span pButtonLabel>{{ 'bookingV2.tour.finish' | translate }}</span>
                    </p-button>
                } @else {
                    <p-button
                        (onClick)="next()"
                        [attr.aria-label]="('bookingV2.tour.nextAria' | translate)">
                        <span pButtonLabel>{{ 'bookingV2.tour.next' | translate }}</span>
                        <span pButtonIcon class="material-icons">chevron_right</span>
                    </p-button>
                }
            </div>
        </div>

    </u2b-dialog>
</div>
